/**
 * Wave 29: Country SEO i18n — Angola 🇦🇴, Czech Republic 🇨🇿
 * + Gap filling for Namibia, Mozambique (missing langs)
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE29: CountrySEOMap = {
  angola: {
    fr: {
      title: 'Centre d\'appel Angola | Externalisation BPO Luanda | Call IT Dev',
      description: 'Externalisez votre centre d\'appel en Angola : agents lusophones, fuseau WAT, CSAT 95%, dès 3$/h.',
      heroTitle: 'Centre d\'appel pour l\'Angola — Support lusophone depuis Casablanca',
      heroSubtitle: 'Service client pour l\'Afrique lusophone à tarif nearshore.',
    },
    es: {
      title: 'Call Center Angola | Externalización BPO Luanda | Call IT Dev',
      description: 'Externalice su call center en Angola: agentes lusófonos, zona WAT, CSAT 95%, desde 3$/h.',
      heroTitle: 'Call Center para Angola — Soporte desde Casablanca',
      heroSubtitle: 'Servicio al cliente para África lusófona a precios nearshore.',
    },
    de: {
      title: 'Callcenter Angola | BPO-Outsourcing Luanda | Call IT Dev',
      description: 'Outsourcen Sie Ihr Callcenter nach Angola: portugiesischsprachige Agenten, WAT-Zone, 95% CSAT, ab 3$/h.',
      heroTitle: 'Callcenter für Angola — Support aus Casablanca',
      heroSubtitle: 'Kundenservice für das lusophone Afrika zu Nearshore-Preisen.',
    },
    ar: {
      title: 'مركز اتصال أنغولا | تعهيد BPO لواندا | Call IT Dev',
      description: 'استعن بمصادر خارجية لمركز الاتصال في أنغولا: وكلاء ناطقون بالبرتغالية، CSAT 95%، من 3$/ساعة.',
      heroTitle: 'مركز اتصال لأنغولا — دعم من الدار البيضاء',
      heroSubtitle: 'خدمة عملاء لأفريقيا الناطقة بالبرتغالية بأسعار نيرشور.',
    },
    pt: {
      title: 'Call Center Angola | Outsourcing BPO Luanda | Call IT Dev',
      description: 'Terceirize seu call center em Angola: agentes lusófonos nativos, fuso WAT, CSAT 95%, a partir de 3$/h.',
      heroTitle: 'Call Center para Angola — Suporte a partir de Casablanca',
      heroSubtitle: 'Atendimento ao cliente para a África lusófona a preços nearshore.',
    },
    it: {
      title: 'Call Center Angola | Outsourcing BPO Luanda | Call IT Dev',
      description: 'Esternalizza il tuo call center in Angola: agenti lusofoni, fuso WAT, CSAT 95%, da 3$/h.',
      heroTitle: 'Call Center per l\'Angola — Supporto da Casablanca',
      heroSubtitle: 'Servizio clienti per l\'Africa lusofona a prezzi nearshore.',
    },
    nl: {
      title: 'Callcenter Angola | BPO Outsourcing Luanda | Call IT Dev',
      description: 'Outsource uw callcenter naar Angola: Portugeestalige agenten, WAT-zone, 95% CSAT, vanaf $3/u.',
      heroTitle: 'Callcenter voor Angola — Support vanuit Casablanca',
      heroSubtitle: 'Klantenservice voor Lusofoon Afrika tegen nearshore-tarieven.',
    },
    pl: {
      title: 'Call Center Angola | Outsourcing BPO Luanda | Call IT Dev',
      description: 'Outsourcing call center do Angoli: portugalskojęzyczni agenci, strefa WAT, CSAT 95%, od 3$/h.',
      heroTitle: 'Call Center dla Angoli — Wsparcie z Casablanki',
      heroSubtitle: 'Obsługa klienta dla Afryki lusofońskiej w cenach nearshore.',
    },
    ru: {
      title: 'Колл-центр Ангола | BPO-аутсорсинг Луанда | Call IT Dev',
      description: 'Аутсорсинг колл-центра в Анголе: португалоязычные операторы, зона WAT, CSAT 95%, от $3/ч.',
      heroTitle: 'Колл-центр для Анголы — поддержка из Касабланки',
      heroSubtitle: 'Обслуживание клиентов для португалоязычной Африки по nearshore-ценам.',
    },
    tr: {
      title: 'Çağrı Merkezi Angola | BPO Outsourcing Luanda | Call IT Dev',
      description: 'Angola çağrı merkezinizi dışarıdan temin edin: Portekizce konuşan temsilciler, CSAT %95, 3$/saat.',
      heroTitle: 'Angola İçin Çağrı Merkezi — Kazablanka\'dan Destek',
      heroSubtitle: 'Lüzofon Afrika için nearshore fiyatlarla müşteri hizmetleri.',
    },
    zh: {
      title: '安哥拉呼叫中心 | BPO外包罗安达 | Call IT Dev',
      description: '外包安哥拉呼叫中心：葡语客服，WAT时区，CSAT 95%，每小时3美元起。',
      heroTitle: '安哥拉呼叫中心 — 来自卡萨布兰卡的支持',
      heroSubtitle: '以近岸价格为葡语非洲提供客户服务。',
    },
    ja: {
      title: 'コールセンター アンゴラ | BPOアウトソーシング ルアンダ | Call IT Dev',
      description: 'アンゴラのコールセンター：ポルトガル語対応、WATタイムゾーン、CSAT 95%、時給3ドルから。',
      heroTitle: 'アンゴラ向けコールセンター — カサブランカからのサポート',
      heroSubtitle: 'ニアショア価格でポルトガル語圏アフリカ向けサービス。',
    },
    ko: {
      title: '콜센터 앙골라 | BPO 아웃소싱 루안다 | Call IT Dev',
      description: '앙골라 콜센터: 포르투갈어 상담원, WAT 시간대, CSAT 95%, 시간당 $3부터.',
      heroTitle: '앙골라 콜센터 — 카사블랑카에서 지원',
      heroSubtitle: '니어쇼어 가격으로 포르투갈어권 아프리카 서비스.',
    },
    sv: {
      title: 'Callcenter Angola | BPO Outsourcing Luanda | Call IT Dev',
      description: 'Outsourca ditt callcenter till Angola: portugisisktalande agenter, WAT-tidszon, 95% CSAT, från $3/h.',
      heroTitle: 'Callcenter för Angola — Support från Casablanca',
      heroSubtitle: 'Kundservice för lusofont Afrika till nearshore-priser.',
    },
    da: {
      title: 'Callcenter Angola | BPO Outsourcing Luanda | Call IT Dev',
      description: 'Outsource dit callcenter til Angola: portugisisktalende agenter, WAT-tidszone, 95% CSAT, fra $3/t.',
      heroTitle: 'Callcenter for Angola — Support fra Casablanca',
      heroSubtitle: 'Kundeservice for lusofont Afrika til nearshore-priser.',
    },
  },

  czech_republic: {
    fr: {
      title: 'Centre d\'appel République Tchèque | Externalisation BPO | Call IT Dev',
      description: 'Externalisez votre centre d\'appel en République Tchèque : agents multilingues, CET, CSAT 95%, dès 3$/h.',
      heroTitle: 'Centre d\'appel pour la République Tchèque',
      heroSubtitle: 'Support multilingue pour l\'Europe centrale à tarif nearshore.',
    },
    es: {
      title: 'Call Center República Checa | Externalización BPO | Call IT Dev',
      description: 'Externalice su call center en República Checa: agentes multilingües, zona CET, CSAT 95%, desde 3$/h.',
      heroTitle: 'Call Center para la República Checa',
      heroSubtitle: 'Soporte multilingüe para Europa Central a precios nearshore.',
    },
    de: {
      title: 'Callcenter Tschechien | BPO-Outsourcing | Call IT Dev',
      description: 'Outsourcen Sie Ihr Callcenter nach Tschechien: mehrsprachige Agenten, CET, 95% CSAT, ab 3$/h.',
      heroTitle: 'Callcenter für Tschechien',
      heroSubtitle: 'Mehrsprachiger Support für Mitteleuropa zu Nearshore-Preisen.',
    },
    ar: {
      title: 'مركز اتصال جمهورية التشيك | تعهيد BPO | Call IT Dev',
      description: 'استعن بمصادر خارجية لمركز الاتصال في التشيك: وكلاء متعددو اللغات، CSAT 95%، من 3$/ساعة.',
      heroTitle: 'مركز اتصال لجمهورية التشيك',
      heroSubtitle: 'دعم متعدد اللغات لأوروبا الوسطى بأسعار نيرشور.',
    },
    it: { title: 'Call Center Repubblica Ceca | Outsourcing BPO | Call IT Dev', description: 'Esternalizza il call center in Repubblica Ceca: agenti multilingue, CET, CSAT 95%, da 3$/h.', heroTitle: 'Call Center per la Repubblica Ceca', heroSubtitle: 'Supporto multilingue per l\'Europa centrale a prezzi nearshore.' },
    pt: { title: 'Call Center República Checa | Outsourcing BPO | Call IT Dev', description: 'Terceirize call center na República Checa: agentes multilíngues, CET, CSAT 95%, a partir de 3$/h.', heroTitle: 'Call Center para a República Checa', heroSubtitle: 'Suporte multilíngue para a Europa Central a preços nearshore.' },
    nl: { title: 'Callcenter Tsjechië | BPO Outsourcing | Call IT Dev', description: 'Outsource callcenter naar Tsjechië: meertalige agenten, CET, 95% CSAT, vanaf $3/u.', heroTitle: 'Callcenter voor Tsjechië', heroSubtitle: 'Meertalige klantenservice voor Centraal-Europa.' },
    pl: { title: 'Call Center Czechy | Outsourcing BPO | Call IT Dev', description: 'Outsourcing call center do Czech: wielojęzyczni agenci, CET, CSAT 95%, od 3$/h.', heroTitle: 'Call Center dla Czech', heroSubtitle: 'Wielojęzyczna obsługa dla Europy Środkowej.' },
    ru: { title: 'Колл-центр Чехия | BPO-аутсорсинг | Call IT Dev', description: 'Аутсорсинг колл-центра в Чехию: многоязычные операторы, CET, CSAT 95%, от $3/ч.', heroTitle: 'Колл-центр для Чехии', heroSubtitle: 'Многоязычная поддержка для Центральной Европы.' },
    tr: { title: 'Çağrı Merkezi Çekya | BPO Outsourcing | Call IT Dev', description: 'Çekya çağrı merkezinizi dışarıdan temin edin: çok dilli temsilciler, CET, CSAT %95, 3$/saat.', heroTitle: 'Çekya İçin Çağrı Merkezi', heroSubtitle: 'Orta Avrupa için çok dilli müşteri hizmetleri.' },
    zh: { title: '捷克呼叫中心 | BPO外包 | Call IT Dev', description: '外包捷克呼叫中心：多语言客服，CET时区，CSAT 95%，每小时3美元起。', heroTitle: '捷克呼叫中心', heroSubtitle: '以近岸价格为中欧提供多语言服务。' },
    ja: { title: 'コールセンター チェコ | BPOアウトソーシング | Call IT Dev', description: 'チェコのコールセンター：多言語対応、CET、CSAT 95%、時給3ドルから。', heroTitle: 'チェコ向けコールセンター', heroSubtitle: 'ニアショア価格で中欧向け多言語サービス。' },
    ko: { title: '콜센터 체코 | BPO 아웃소싱 | Call IT Dev', description: '체코 콜센터: 다국어 상담원, CET 시간대, CSAT 95%, 시간당 $3부터.', heroTitle: '체코 콜센터', heroSubtitle: '니어쇼어 가격으로 중앙 유럽 다국어 서비스.' },
    sv: { title: 'Callcenter Tjeckien | BPO Outsourcing | Call IT Dev', description: 'Outsourca till Tjeckien: flerspråkiga agenter, CET, 95% CSAT, från $3/h.', heroTitle: 'Callcenter för Tjeckien', heroSubtitle: 'Flerspråkig kundservice för Centraleuropa.' },
    da: { title: 'Callcenter Tjekkiet | BPO Outsourcing | Call IT Dev', description: 'Outsource til Tjekkiet: flersprogede agenter, CET, 95% CSAT, fra $3/t.', heroTitle: 'Callcenter for Tjekkiet', heroSubtitle: 'Flersproget kundeservice for Centraleuropa.' },
  },

  // Gap fill: Mozambique missing langs
  mozambique: {
    zh: { title: '莫桑比克呼叫中心 | BPO外包马普托 | Call IT Dev', description: '外包莫桑比克呼叫中心：葡语客服，CAT时区，CSAT 95%，每小时3美元起。', heroTitle: '莫桑比克呼叫中心', heroSubtitle: '以近岸价格为东非提供葡语服务。' },
    ja: { title: 'コールセンター モザンビーク | BPOアウトソーシング | Call IT Dev', description: 'モザンビークのコールセンター：ポルトガル語対応、CSAT 95%、時給3ドルから。', heroTitle: 'モザンビーク向けコールセンター', heroSubtitle: 'ニアショア価格で東アフリカ向けポルトガル語サービス。' },
    ko: { title: '콜센터 모잠비크 | BPO 아웃소싱 | Call IT Dev', description: '모잠비크 콜센터: 포르투갈어 상담원, CSAT 95%, 시간당 $3부터.', heroTitle: '모잠비크 콜센터', heroSubtitle: '니어쇼어 가격으로 동아프리카 포르투갈어 서비스.' },
    sv: { title: 'Callcenter Moçambique | BPO Outsourcing | Call IT Dev', description: 'Outsourca till Moçambique: portugisisktalande agenter, 95% CSAT, från $3/h.', heroTitle: 'Callcenter för Moçambique', heroSubtitle: 'Portugisiskspråkig kundservice för Östafrika.' },
    da: { title: 'Callcenter Mozambique | BPO Outsourcing | Call IT Dev', description: 'Outsource til Mozambique: portugisisktalende agenter, 95% CSAT, fra $3/t.', heroTitle: 'Callcenter for Mozambique', heroSubtitle: 'Portugisisktalende kundeservice for Østafrika.' },
  },

  // Gap fill: Slovenia missing langs
  slovenia: {
    zh: { title: '斯洛文尼亚呼叫中心 | BPO外包卢布尔雅那 | Call IT Dev', description: '外包斯洛文尼亚呼叫中心：多语言客服，CET时区，CSAT 95%，每小时3美元起。', heroTitle: '斯洛文尼亚呼叫中心', heroSubtitle: '以近岸价格为中欧提供服务。' },
    ja: { title: 'コールセンター スロベニア | BPOアウトソーシング | Call IT Dev', description: 'スロベニアのコールセンター：多言語対応、CET、CSAT 95%、時給3ドルから。', heroTitle: 'スロベニア向けコールセンター', heroSubtitle: 'ニアショア価格で中欧向けサービス。' },
    ko: { title: '콜센터 슬로베니아 | BPO 아웃소싱 | Call IT Dev', description: '슬로베니아 콜센터: 다국어 상담원, CET 시간대, CSAT 95%, 시간당 $3부터.', heroTitle: '슬로베니아 콜센터', heroSubtitle: '니어쇼어 가격으로 중앙 유럽 서비스.' },
    sv: { title: 'Callcenter Slovenien | BPO Outsourcing | Call IT Dev', description: 'Outsourca till Slovenien: flerspråkiga agenter, CET, 95% CSAT, från $3/h.', heroTitle: 'Callcenter för Slovenien', heroSubtitle: 'Kundservice för Centraleuropa.' },
    da: { title: 'Callcenter Slovenien | BPO Outsourcing | Call IT Dev', description: 'Outsource til Slovenien: flersprogede agenter, CET, 95% CSAT, fra $3/t.', heroTitle: 'Callcenter for Slovenien', heroSubtitle: 'Kundeservice for Centraleuropa.' },
  },

  // Gap fill: Cyprus missing langs
  cyprus: {
    zh: { title: '塞浦路斯呼叫中心 | BPO外包尼科西亚 | Call IT Dev', description: '外包塞浦路斯呼叫中心：多语言客服，EET时区，CSAT 95%，每小时3美元起。', heroTitle: '塞浦路斯呼叫中心', heroSubtitle: '以近岸价格为地中海地区提供服务。' },
    ja: { title: 'コールセンター キプロス | BPOアウトソーシング | Call IT Dev', description: 'キプロスのコールセンター：多言語対応、EET、CSAT 95%、時給3ドルから。', heroTitle: 'キプロス向けコールセンター', heroSubtitle: 'ニアショア価格で地中海地域向けサービス。' },
    ko: { title: '콜센터 키프로스 | BPO 아웃소싱 | Call IT Dev', description: '키프로스 콜센터: 다국어 상담원, EET 시간대, CSAT 95%, 시간당 $3부터.', heroTitle: '키프로스 콜센터', heroSubtitle: '니어쇼어 가격으로 지중해 지역 서비스.' },
    sv: { title: 'Callcenter Cypern | BPO Outsourcing | Call IT Dev', description: 'Outsourca till Cypern: flerspråkiga agenter, EET, 95% CSAT, från $3/h.', heroTitle: 'Callcenter för Cypern', heroSubtitle: 'Kundservice för Medelhavsregionen.' },
    da: { title: 'Callcenter Cypern | BPO Outsourcing | Call IT Dev', description: 'Outsource til Cypern: flersprogede agenter, EET, 95% CSAT, fra $3/t.', heroTitle: 'Callcenter for Cypern', heroSubtitle: 'Kundeservice for Middelhavsregionen.' },
  },
};
